<template>
  <vue-bottom-sheet ref="myBottomSheet" :rounded="true" @closed="tipsAmount=null">
    <div style="max-height: 90vh; max-width: 100vw">
      <div class="modal-close-button d-flex align-items-center" @click="close">
        <span class="material-icons pl-2">close</span>
      </div>
      <div class="modal-body p-2">
        <span class="font-16 p-2 pl-4"> {{ $t('message.wouldLikeAddTip') }}</span>
        <p class="font-13 p-2 mb-0 pl-4"> {{ $t('message.tipsInfo') }}</p>
        <div class="tip-group px-2">
          <div v-for="tip in this.tips" :key="tip.id" :style="tipSelected === tip.id && 'border:2px solid #000000'"
               class="tip-box">
            <div v-if="tip.id ===0"
                 :style="{'border-color' : tipSelected === tip.id ? 'black' : 'grey'}" @click="selectTip(tip.id, tip.percentValue)">
            <span class="tip-box-percent d-block p-2 pl-3 ml-1">
                 {{ tip.percentName }}
            </span>
            </div>
            <div v-else :style="{'border-color' : tipSelected === tip.id ? 'black' : 'grey'}"
                 @click="selectTip(tip.id, tip.percentValue)">
            <span class="tip-box-percent d-block"
            >{{ tip.percentName }}</span>
              <span class="d-block font-13"
              >${{ tipsValue(tip.percentValue).toFixed(2) }}</span>
            </div>
          </div>
        </div>
        <div class="input-group pt-3 pl-3 pr-3">
          <div class="form-group has-search w-100 d-flex align-items-center">
            <span class="fa fa-dollar form-control-feedback text-dark"></span>
            <input v-model="tipsHandler" class=" form-control"
                   placeholder="Or add a custom tip"
                   min="0"
                   style=" background-color: #EDF2F7; border-bottom-color: #ced4da !important; height: 48px" type="number">
            <span class="fa fa-pencil form-control-feedback-edit text-white bg-dark"></span>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <button :disabled="storeClosed" :style="orderButtonStyles" aria-label="Close"
                  class="btn bg-black text-white d-flex justify-content-center align-items-center"
                  data-dismiss="modal"
                  style="border-radius: 1rem; width: 90vw; height: 48px"
                  type="button" @click="close()">
         <span class="w-100">
            {{ $t('message.confirm') }}
         </span>
            <svg color="white" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                 stroke-linejoin="round" stroke-width="2" style="color: white;" viewBox="0 0 24 24" width="24"
                 xmlns="http://www.w3.org/2000/svg">
              <line x1="5" x2="19" y1="12" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>

  </vue-bottom-sheet>
</template>


<style>
.modal-close-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin: -7vh 3vw 0 0;
}

.bill-close-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.9);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin: 10px 3vw 0 0;
}

.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  line-height: 2.375rem;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.has-search .form-control-feedback-edit {
  position: absolute;
  z-index: 2;
  display: block;
  margin-left: 82% ;
  width: 30px;
  height: 30px;
  line-height: 2rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  border-radius: 50%;
}
</style>
<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import {mapGetters} from "vuex";

export default {
  components: {
    VueBottomSheet
  },
  methods: {
    open() {
      this.$refs.myBottomSheet.open();
    },
    close() {
      this.$refs.myBottomSheet.close();
    }
    // closeAndNavigateToCheckout(){
    //   this.close()
    //   this.navigateToCheckout()
    // }
  },
  computed: {
    ...mapGetters(["desktopStyles", "cartItems", "selectedCompany", "getTipCustomAmount"]),
    orderButtonStyles() {
      return {
        ...this.desktopStyles.btn,
        ...this.desktopStyles.desktopPlaceOrderButton,
      };
    },

    tipsHandler: {
      get() {
        return this.getTipCustomAmount
      },
      set(val) {
        let value = Number(val);
        if (value < 0) value = 0;
        this.selectCustomTip(value)
      }
    }
  },

  props: {
    tips: {
      type: Array,
      default: () => []
    },
    tipSelected: {
      type: Number,
      default: 0
    },
    tipsValue: {
      type: Function,
      default: () => 0
    },
    navigateToCheckout: {
      type: Function,
      default: () => {
      }
    },
    selectTip: {
      type: Function,
      default: () => {
      }
    },
    storeClosed: {
      type: Boolean,
      default: false
    },
    selectCustomTip : {
      type: Function,
      default: () => {
      }
    }

  },

}
</script>
